const usingServiceAdvantage = {
  en: {
    title: 'Raise Your Bar With The Best Bar POS System',
    // desc: 'Simple, personalized orders, and speedy delivery.',
    items: [
      {
        title: 'Fast, Effortless Bar Service',
        image: `${process.env.ASSETS_PREFIX}/businesstype/fancy-restaurant-bar-top.jpg`,
        items: [
          {
            desc: 'Quickly serve patrons in less time with QR code digital menus, handhelds, mobile ordering, and more.',
          },
          {
            desc: 'Simplify a hectic bar environment with orders firing directly to your kitchen and POS system from the hands of guests.',
          },
          {
            desc: 'More drinks, more appetizers, more sales in less time! Our average POS customer sees big improvements in their table turn over time.',
          },
        ],
      },
      {
        title: 'Top Shelf POS Features & Hardware ',
        image: `${process.env.ASSETS_PREFIX}/businesstype/top-shelf-alcohol-bottles-at-bar.jpg`,
        items: [
          {
            desc: 'Use our POS tab feature specifically designed for bar operations',
          },
          {
            desc: 'From handheld tablets to self-ordering kiosks, our POS hardware and software works in harmony across your operation.',
          },
          {
            desc: '24/7 customer support for any late night troubleshooting.',
          },
        ],
      },
      {
        title: 'More Speed, More Profits',
        image: `${process.env.ASSETS_PREFIX}/businesstype/bar-guests-cheering.jpg`,
        items: [
          {
            desc: ' Our POS system saves the average restaurant up to $8,000/month in labor costs',
          },
          {
            desc: 'Save your time and effort on performance reporting. We automate it for you!',
          },
          {
            desc: 'Our POS removes redundant costly tasks, which can boost sales volume, tips, staff productivity, and your bottom line!',
          },
          {
            desc: 'Use our loyalty, CRM, and gift card programs to turn one-time customers into your regulars!',
          },
        ],
      },
    ],
  },

  zh: {
    title: '用最好的酒吧系统提升你的酒吧',
    items: [
      {
        title: '升级顾客体验',
        image: `${process.env.ASSETS_PREFIX}/businesstype/fancy-restaurant-bar-top.jpg`,
        items: [
          {
            desc: '顾客进店即可查看电子餐单通过图片和描述更好地了解菜品',
          },
          {
            desc: '顾客可以通过扫码/平板点单，实现从下单到支付的全自助服务',
          },
          {
            desc: '顾客可以随时添加餐品，减少等待时间的同时提升餐厅的翻桌率',
          },
        ],
      },

      {
        title: '减少等待时间',
        image: `${process.env.ASSETS_PREFIX}/businesstype/op-shelf-alcohol-bottles-at-bar.jpg`,
        items: [
          {
            desc: '线上取号了解排队时间，短信提醒到店用餐，减少顾客等位时间',
          },
          {
            desc: '顾客可以使用二维码、平板等自助下单，减少等待点餐的时间',
          },
          {
            desc: '顾客一键下单，订单直达后厨，减少顾客等待餐品的时间',
          },
        ],
      },
      {
        title: '提升餐厅利润',
        image: `${process.env.ASSETS_PREFIX}/businesstype/bar-guests-cheering.jpg`,
        items: [
          {
            desc: '我们的POS产品帮助您在点单、结账、订单管理等环节显著减少人力成本',
          },
          {
            desc: '关注顾客复购率，善用会员、积分、礼品卡、营销短信等方式发展您的回头客，提升营业额',
          },
          {
            desc: '更快的服务、更优的顾客体验有效提升顾客的复购率及营业额',
          },
          {
            desc: '我们提供24/7小时客服支持，即使在深夜也能及时响应',
          },
        ],
      },
    ],
  },
};

export default usingServiceAdvantage;
